/**
 * Check if two element IDs conflict.
 * Simplified conflict detection: currently we only check for direct ID conflicts.
 * This simplified approach may need to be expanded in the future to include
 * hierarchical checks (parent-child relationships, containment checks, etc.)
 * if more complex replacement scenarios arise.
 */

const hasElementConflict = (elementId1, elementId2) => {
  if (!elementId1 || !elementId2) {
    return false;
  }

  return elementId1 === elementId2;
};

export default hasElementConflict;
